<template>
	<div>
		<div v-if="form">
			<table class="table">
				<tr>
					<th v-for="date in relevant_dates">{{ date.replace(/_/g, ' ') }}</th>
					<th>LAST DOCUMENT DATE</th>
				</tr>
				<tr>
					<td v-for="date in relevant_dates">
						<p v-if="offer[date]">{{ time_helper.makeTimeReadable(offer[date]) }}</p>
					</td>
					<td>
						<p>{{ time_helper.makeTimeReadable($offers_helper.getLastDocumentDate(offer)) }}</p>
					</td>
				</tr>
			</table>
			<div class="vertical_space"></div>
			<div>
				<div class="flex flex_justify_center">
					<checkbox v-model="is_anonymous" :checked="is_anonymous">דיסקרטי</checkbox>
				</div>
				<div class="vertical_space"></div>
				<div class="flex flex_align_center flex_justify_center flex_wrap">
					<div v-for="(data, document_type) in getDocumentTypes">
					  	<a @click="selectDocumentType(document_type)" class="button is-info" style="margin: 5px 7px;" 
					  	 	:class="{ 'is-outlined': form.data.send_document.fields.document_type.value != document_type }">	
					  		{{ data.display_name }}
					  	</a>
					</div>
				</div>
			</div>
			<div class="vertical_space"></div>
			<div :class="{ hide: form.data.send_document.fields.document_type.value == undefined }">
				<div>
			        <div class="text_align_left">
			          <p><b>title</b></p>
			          <input dir="ltr" class="full_width" type="text" v-model="form.data.send_document.fields.title.value" 
			          		  :class="{ field_error: form.data.send_document.fields.title.has_error }"
			          		  @focus="form.data.send_document.fields.title.has_error = false" />
			        </div>
			        <div class="vertical_space"></div>
			        <div class="text_align_left">
			          <p><b>greetings</b></p>
			          <textarea class="full_width" v-model="form.data.send_document.fields.greetings.value" 
			          		  :class="{ field_error: form.data.send_document.fields.greetings.has_error }"
			          		  @focus="form.data.send_document.fields.greetings.has_error = false"></textarea>
			        </div>
			        <div class="vertical_space"></div>
			        <div>
			          	<p class="text_align_left"><b>manual_text</b></p>
		          		<textarea class="full_width" v-model="form.data.send_document.fields.manual_text.value"></textarea>
			        </div>
			        <div class="vertical_space"></div>
			        <div dir="ltr">
						<div class="text_align_left">
							<p><b>email</b></p>
							<textarea class="full_width text_align_left" v-model="form.data.send_document.fields.email.value" 
									  :class="{ field_error: form.data.send_document.fields.email.has_error }"
									  @focus="form.data.send_document.fields.email.has_error = false"></textarea>
						</div>
						<div class="flex flex_justify_between text_align_right">
							<a @click="internal" class="button is-info">Internal</a>
							<checkbox
							  :checked="is_set_contact_email"
							  v-model="is_set_contact_email"
							  >Use this email for this position</checkbox
							>
						</div>
						<div v-if="isShowBccCheckBox(selected_document_type)">
							<checkbox
							  :checked="form.data.send_document.fields.send_bcc_to_accountant.value"
							  v-model="form.data.send_document.fields.send_bcc_to_accountant.value"
							  >Send bcc to accountant ({{ accountant_email }})</checkbox
							>
						</div>
			        </div>
				</div>
				<div>
		     	    <p><b>קבצים</b></p>
					<files ref="files" @selected_files="selected_files = $event" v-model="files" :payload="{ resource_type: 'Offer', resource_id: payload.data.id, show_checkboxes: is_send_files }">
					</files>
					<div style="margin-top: 6px;">
						<a @click="generateDocument('payment_request', 'הפקת דרישת תשלום')" class="button is-info">הפק דרישת תשלום</a>
					</div>
					<div style="margin-top: 6px;">
						<a @click="generateDocument('invoice', 'הפקת חשבונית מס')" class="button is-info">הפק חשבונית מס</a>
					</div>
					<div style="margin-top: 6px;">
						<a @click="generateDocument('invoice_and_receipt', 'הפקת חשבונית מס קבלה')" class="button is-info">הפק חשבונית מס קבלה</a>
					</div>
					<div style="margin-top: 6px;">
						<a @click="generateDocument('receipt', 'הפקת קבלה')" class="button is-info">הפק קבלה</a>
					</div>
					<div style="margin-top: 15px;">
						<checkbox @input="is_send_files = !($event)">
							אני לא מעוניין לשלוח קבצים
						</checkbox>	
					</div>
				</div>
		        <div class="vertical_space"></div>
		        <div class="vertical_space"></div>
		        <div class="vertical_space"></div>
		        <div class="vertical_space"></div>
			</div>
		</div>
		<div v-else class="flex flex_align_center flex_justify_center">
			<div class="loading"></div>
		</div>
		<div class="modal_footer flex flex_justify_between">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading, faded: isSubmitFaded }"
				class="button is-info"
				>Submit</a
			>
			<div>ENV OFFER ID: {{ env_offer_id }}</div>
		</div>
	</div>
</template>
<script>
	import { mapMutations, mapActions } from 'vuex'
	import Validator from '@/classes/validator.js'
	import TimeHelper from '@/classes/time_helper.js'
	import EmailTemplateHelper from '@/classes/email_template_helper.js'
	import TextsHelper from '@/classes/texts_helper.js'
	import Checkbox from '@/components/Checkbox'
	import Files from '@/components/Files'
	export default {
		name: 'payment-request-form',
		props: ['payload'],
		data(){
			return{
				env: '',
				accountant_email: 'kaplanyuval@walla.com',
				relevant_dates: this.$offers_helper.getRelevantDates(),
				offer: {},
				validator: new Validator(),
				time_helper: new TimeHelper(),
				selected_files: [],
				files: [],
				is_send_files: true,
				email_template_helper: undefined,
				texts_helper: new TextsHelper(),
				is_loading: false,
				is_set_contact_email: true,
				payment: 0,
				form: undefined,
				is_anonymous: false,
				selected_document_type: undefined,
				isLocked: false,
				env_offer_id: null
			}
		},
		computed: {
			isSubmitFaded(){
				if(this.form == undefined || this.form.data.send_document.fields.document_type.value == undefined){
					return true
				}
				return this.is_send_files && this.selected_files.length == 0 && !this.isLocked
			},
			getDocumentTypes(){
				return this.email_template_helper.getDocumentTypes()
			},
			getAnonymousDoumentTypes(){
				return this.email_template_helper.getAnonymousDocumentTypes()
			}
		},
		created(){
			this.setOffer()
		},
		watch: {
			is_anonymous(){
				this.selectDocumentType(this.selected_document_type)
			}
		},
		methods: {
			setOffer(){
				this.$network_utils.getOffer(this.payload.data.id).then(response => {
					if(!response.maturation_days ) {
						this.isLocked = true
						this.showToast('חסרים ימים לדרישת תשלום בבסיס נתונים')
					}
					this.offer = response
					this.is_anonymous = this.offer.company.is_discreet
					this.email_template_helper = new EmailTemplateHelper(response)
					this.payment = this.$offers_helper.getPayment(response)
					this.setForm(response)
					this.env_offer_id =response.env_offer_id
				})
			},
			setForm(offer){
				this.form = new this.$form({
					send_document: {
					  fields: {
					    title: {
					    	value: '',
					    	has_error: false,
					    	validations: ['Exists']
					    },
					    greetings: {
					    	value: 'שלום רב,\n^^ברכות על עוד גיוס מוצלח!^^',
					    	has_error: false,
					    	validations: ['Exists']
					    },
					    manual_text: {
					    	value: '',
					    	has_error: false,
					    	validations: []
					    },
					    email: {
					    	value: offer.company.email,
					    	has_error: false,
					    	validations: ['Exists']
					    },
					    offer_id: {
					    	value: offer.id,
					    	has_error: false,
					    	validations: ['Exists']
					    },
					    document_type: {
					    	value: undefined,
					    	has_error: false,
					    	validations: ['Exists']
					    },
					    send_bcc_to_accountant: {
					    	value: false,
					    	has_error: false,
					    	validations: []
					    },
					    files: {
					    	value: '',
					    	has_error: false,
					    	validations: []
					    }
					  },
					  request_details: {
					    method: 'post',
					    url: '/send_document/',
					  },
					  is_used: true
					}
				})
			},
			selectDocumentType(document_type){
				if(document_type == undefined){
					return
				}
				this.selected_document_type = document_type
				let document_type_data = this.getDocumentTypes[this.selected_document_type]
				let title = document_type_data.title
				let manual_text = document_type_data.manual_text
				let greetings = document_type_data.greetings || `שלום רב,\n`
				if(this.is_anonymous){
					greetings = `שלום רב,\n`
					title = document_type_data.anonymous.title
					manual_text = document_type_data.anonymous.manual_text || document_type_data.manual_text
				}
				this.form.data.send_document.fields.greetings.value = greetings
				this.form.data.send_document.fields.document_type.value = this.selected_document_type
				this.form.data.send_document.fields.title.value = title
				this.form.data.send_document.fields.manual_text.value = manual_text
			},
			internal(){
				this.form.data.send_document.fields.email.value = this.$settings.get({ path: 'operation_email' })
				this.is_set_contact_email = false
			},
			saveContactEmail(){
				this.$network_utils.updateAccountingCompany({ id: this.offer.company_id, email: this.form.data.send_document.fields.email.value })
			},
			generateDocument(document_type, modal_title){
				this.createModal({
					designator: 'generate-document-modal',
					component_name: 'GenerateDocument',
					modal_title: modal_title,
					is_anonymous: this.is_anonymous,
					document_type,
					offer: this.offer,
					callback: () => {
						this.$refs.files.init()
					}
				})
			},
			isShowBccCheckBox(document_type){
				return ['invoice_and_receipt', 'receipt', 'invoice'].includes(document_type)
			},
			submit(){
				if(!this.validator.multipleEmailsValidationSanity(this.form.data.send_document.fields.email.value)){
					return
				}
				if(this.payment <= 0){
					this.showToast('אי אפשר לשלוח דרישת תשלום עם תשלום 0')
					return
				}
				let manual_text_content = this.form.data.send_document.fields.manual_text.value
				let bold_content = this.texts_helper.getBoldContent(manual_text_content, 'manual_text')
				if (bold_content == 'problem') {
					return
				}
				this.form.data.send_document.fields.files.value = this.is_send_files ? this.selected_files.join(',') : ''
				this.form.data.send_document.fields.manual_text.value = bold_content

				let greetings_content = this.form.data.send_document.fields.greetings.value
				bold_content = this.texts_helper.getBoldContent(greetings_content, 'greetings')
				if (bold_content == 'problem') {
					return
				}
				this.form.data.send_document.fields.greetings.value = bold_content

				let response = this.form.mySubmit()
				if (response === false) {
					this.form.data.send_document.fields.manual_text.value = manual_text_content
					return
				}
				if(this.is_set_contact_email){
					this.saveContactEmail()
				}
				this.is_loading = true
				response.promise.then((response) => {
					this.form.data.send_document.fields.manual_text.value = manual_text_content
					this.is_loading = false
					this.showToast(`${this.getDocumentTypes[this.selected_document_type].display_name} נשלחה בהצלחה למעסיק`)
					this.closeSendDocumentForm()
				})
			},
			closeSendDocumentForm(){
				if(this.selected_document_type != 'invoice'){
					this.removeModal(this.payload)
					return
				}
				this.$network_utils.getOffer(this.offer.id).then(response => {
					let new_message = 'הופקה חשבונית, טרם התקבל תשלום'
					let message = (response.message == undefined || response.message.length == 0) ? new_message : (response.message + '\n\n' + new_message)
					this.$network_utils.updateOffer({ id: this.offer.id, message })
					this.removeModal(this.payload)
				})
			},
			...mapActions('toasts', ['showToast']),
			...mapMutations('modals', ['createModal', 'removeModal'])
		},
		components: {
			Checkbox,
			Files,
		}
	}
</script>
<style scoped>
	.hide{
		display: none;
	}
</style>